
const isDev = process.env.NODE_ENV === "development";

export const apiLogger = {
  request: (config: any) => {},
  response: (response: any) => {},
  error: (error: any) => {},
  auth: (message: string) => {},
};
